module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("市场管理")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("分享有礼海报管理")])], 1)], 1), _vm._v(" "), _c('div', [_c('Form', {
    attrs: {
      "label-width": 100,
      "show-message": false,
      "label-position": "left"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 32
    }
  }, [_c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "归属活动"
    }
  }, [_c('Col', [_c('activity-select', {
    attrs: {
      "label": _vm.name
    },
    model: {
      value: (_vm.queryParams.activityId),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "activityId", $$v)
      },
      expression: "queryParams.activityId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 60,
      "label": "海报分类"
    }
  }, [_c('Col', [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.sharePosterType),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "sharePosterType", $$v)
      },
      expression: "queryParams.sharePosterType"
    }
  }, _vm._l((_vm.$constant.sharePosterType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                  " + _vm._s(item.text) + "\n                ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 40,
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "clearable": ""
    },
    model: {
      value: (_vm.queryParams.status),
      callback: function($$v) {
        _vm.$set(_vm.queryParams, "status", $$v)
      },
      expression: "queryParams.status"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "0"
    }
  }, [_vm._v("禁用")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "xs": 11,
      "sm": 6,
      "md": 5
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("\n            搜索\n          ")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "type": "flex",
      "justify": "end"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading
    },
    on: {
      "click": _vm.toShowAddposterModel
    }
  }, [_vm._v("\n          添加海报\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('List', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "tableColumns": _vm.tableColumns,
      "listUrl": "/share/poster/page",
      "params": _vm.queryParams,
      "onLoading": _vm.onLoading,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('CreateShareModal', {
    attrs: {
      "uid": _vm.uid,
      "successCallback": _vm.search
    },
    on: {
      "on-close": _vm.closeModal
    },
    model: {
      value: (_vm.showAddPosterModel),
      callback: function($$v) {
        _vm.showAddPosterModel = $$v
      },
      expression: "showAddPosterModel"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "编辑海报"
    },
    model: {
      value: (_vm.showUpdatePosterModel),
      callback: function($$v) {
        _vm.showUpdatePosterModel = $$v
      },
      expression: "showUpdatePosterModel"
    }
  }, [_c('Form', {
    ref: "updatePosterForm",
    staticClass: "form",
    attrs: {
      "rules": _vm.shareRules,
      "model": _vm.updatePosterParams
    }
  }, [_c('Row', [_c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "海报名称：",
      "prop": "name"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入活动名称用于列表展示"
    },
    model: {
      value: (_vm.updatePosterParams.name),
      callback: function($$v) {
        _vm.$set(_vm.updatePosterParams, "name", $$v)
      },
      expression: "updatePosterParams.name"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "海报分类：",
      "prop": "sharePosterType"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.updatePosterParams.sharePosterType),
      callback: function($$v) {
        _vm.$set(_vm.updatePosterParams, "sharePosterType", $$v)
      },
      expression: "updatePosterParams.sharePosterType"
    }
  }, _vm._l((_vm.$constant.sharePosterType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n            ")])
  }), 1)], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "活动归属：",
      "prop": "activityId"
    }
  }, [_c('activity-select', {
    attrs: {
      "label": _vm.name
    },
    model: {
      value: (_vm.updatePosterParams.activityId),
      callback: function($$v) {
        _vm.$set(_vm.updatePosterParams, "activityId", $$v)
      },
      expression: "updatePosterParams.activityId"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "配套海报：",
      "prop": "url"
    }
  }, [_c('image-upload-New', {
    attrs: {
      "defaultFileList": _vm.updateDefalutPic
    },
    model: {
      value: (_vm.updatePosterParams.url),
      callback: function($$v) {
        _vm.$set(_vm.updatePosterParams, "url", $$v)
      },
      expression: "updatePosterParams.url"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "海报排序：",
      "prop": "sort"
    }
  }, [_c('InputNumber', {
    attrs: {
      "min": 0,
      "max": 100000
    },
    model: {
      value: (_vm.updatePosterParams.sort),
      callback: function($$v) {
        _vm.$set(_vm.updatePosterParams, "sort", $$v)
      },
      expression: "updatePosterParams.sort"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label-width": 90,
      "label": "海报状态：",
      "prop": "status"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.updatePosterParams.status),
      callback: function($$v) {
        _vm.$set(_vm.updatePosterParams, "status", $$v)
      },
      expression: "updatePosterParams.status"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "no"
    }
  }, [_vm._v("禁用")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "yes"
    }
  }, [_vm._v("启用")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showUpdatePosterModel = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingAddPoster
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bdb029c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/market/ShareManagement.vue
// module id = 1664
// module chunks = 8